(ns com.theplantscape.web-ui.tailwind.command-dialog
  (:require
   [reagent.core :as r]))

(defn select-tool [tools]
  (let [search (r/atom nil)]
    (fn [tools opts]
      [:div.p-6.text-center
       ;[:h3.mb-5.text-lg.font-normal.text-gray-500.dark:text-gray-400 "Select / Search for a tool"]
       [:input.border-1.w-full.h-8 {:autoFocus "autofocus" :on-change #(reset! search (-> % .-target .-value))}]
       (into [:ul.w-full]
             (mapv (fn select-tool-item
                     [{:keys [tool/action tool/usage tool/name tool/icon tool/label tool/description] :as tool}]
                     [:li.text-left.w-full.m-4
                      {:on-click #((:select-tool opts) tool)}
                      [:div
                       [:i.mr-4.fas {:class icon} [:span.ml-4 label]]]
                      [:div.text-xs (str usage " - " description)]])
                   (reverse (sort-by
                             :tool/usage
                             (filter (fn [{:keys [tool/label]}]
                                       (if (string? @search)
                                         (some? (re-find (re-pattern (str "(?i)" @search)) label))
                                         true))
                                     tools)))))])))


